import { PureComponent } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Button, Container, Grid } from 'semantic-ui-react';

import { APP_NAME } from '../../utils/constant';
import { forgotPassword } from '../../store/actions';
import { INSTANCE_CONTACT_EMAIL } from '../../utils/instanceConstant';

import './auth.scss';

class ForgotPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: false,
    };
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.forgot_password')} | ${APP_NAME}`;
  }

  async handleValidSubmit(event, values) {
    const { forgotPassword } = this.props;
    if (await forgotPassword(values.email)) {
      this.setState({ email: values.email });
    }
  }

  render() {
    const { forgotPassLoading, t } = this.props;
    const { email } = this.state;
    return (
      <Grid.Row>
        <Grid.Column mobile={16} tablet={16} computer={8} />
        <Grid.Column mobile={16} tablet={16} computer={8}>
          {email ? (
            <Container className="right-heading-container">
              <label className="headerText">
                {t('auth.forgot_password.title')}
              </label>
              <br />
              <label className="headerDescription">
                {t('auth.forgot_password.subtitle')}
              </label>
              <label className={'recoverySub'}>
                {t('auth.forgot_password.recovery_sub')}
              </label>
              <label className={'recoveryEmail'}>{email}</label>
              <Link to={'/signin'}>
                <label className={'backToSignIn'}>
                  {t('auth.forgot_password.back_to_signin')}
                </label>
              </Link>
              <div className={'footerContainer'}>
                <label className={'footerContent'}>
                  {t('common.no_access')}
                </label>
                <br />
                <a
                  className="contactUs"
                  href={`mailto:${INSTANCE_CONTACT_EMAIL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('auth.forgot_password.contact_us')}
                </a>
              </div>
            </Container>
          ) : (
            <Container className="right-heading-container">
              <label className="headerText">
                {t('auth.forgot_password.form_title')}
              </label>
              <label className="headerDescription">
                {t('auth.forgot_password.form_subtitle')}
              </label>
              <br />
              <label className="headerNotification">
                {t('auth.forgot_password.instructions')}
              </label>
              <AvForm
                className={'form-group-conatiner'}
                onValidSubmit={(event, values) =>
                  this.handleValidSubmit(event, values)
                }
              >
                <AvField
                  label={t('common.email')}
                  className="signin-inputs"
                  placeholder={t('auth.forgot_password.email_placeholder')}
                  name="email"
                  type="email"
                  errorMessage={t('auth.forgot_password.invalid_email')}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t('formulary.validation.email_required'),
                    },
                  }}
                />
                <br />
                <Button
                  type="submit"
                  className="btn btn-primary signin-button"
                  loading={forgotPassLoading}
                  disabled={forgotPassLoading}
                >
                  {t('auth.forgot_password.reset_button')}
                </Button>
                <Link to={'/signin'}>
                  <label className={'goBackSignIn'}>
                    {t('auth.forgot_password.back_to_signin')}
                  </label>
                </Link>
              </AvForm>
            </Container>
          )}
        </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} />
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      forgotPassword,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ForgotPassword));
